import React from 'react';
import Gallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css'; // 라이브러리 스타일 시트 임포트

const LabImageViewer: React.FC = () => {

    const images = [
        {
            original: "./resources/conference.png",
            thumbnail: "./resources/conference.png",            
        },
        {
            original: "./resources/lab1.png",
            thumbnail: "./resources/lab1.png",            
        },
        {
            original: "./resources/lab2.png",
            thumbnail: "./resources/lab2.png",            
        },
        {
            original: "./resources/lab3.png",
            thumbnail: "./resources/lab3.png",            
        },
    ];

    return (
        <div id="features-wrapper">
            <div className="imageviewer">
                <div className="gallery-centered">            
                <Gallery items={images} autoPlay={true} slideInterval={5000} />
                </div>
            </div>
        </div>

    );
}

export default LabImageViewer;
